













import Vue from 'vue';
import Component from 'vue-class-component';
import 'firebase/auth';
import SignInDialog from '@/components/Auth/SignInDialog.vue';
import LocaleSelector from '@/components/Shared/LocaleSelector.vue';

@Component({
  components: {
    LocaleSelector,
    SignInDialog,
  },
})
export default class ActionsUnauthenticated extends Vue {
  dialog: boolean = false;
}
